/** The `suggestions` area: the doors out of a statement on the item page
 *  (src/domain/suggestions.ts). A door wears the act or the state it applies. */
export const suggestions = {
  'suggestions.door.redate': 'Re-date',
  'suggestions.door.deliver': 'Done',
  'suggestions.door.active': 'Active',
  'suggestions.door.idle': 'Idle',
  'suggestions.door.revisit': 'Revisit',
  'suggestions.door.reopen': 'Reopen',
  'suggestions.door.contain': 'Not affected',
} as const;
